/**
 * Selectively load from autoload to permit inheritance to child-theme
 **/
import "./autoload/_bootstrap";
import "./autoload/_custom";

// import local dependencies
import Router from "./util/Router";
import common from "./routes/common";
import home from "./routes/home";
import templateHittaBygdegard from "./routes/templateHittaBygdegard";
import sticky from "./custom/sticky";
import menus from "./custom/menus";
import searchBar from "./custom/searchBar";

/** Populate Router instance with DOM routes */
const routes = new Router({
  common,
  home,
  templateHittaBygdegard,
});

// Load Events
$(document).on("ready", () => routes.loadEvents());
$(window).on("pageshow", () => {
  sticky.header();
  menus.navigation();
  menus.districts();
  menus.mobile();
  menus.sidebar();
  searchBar.expandInput();
});
